<template>
  <div v-if="state">
    <CRow>
      <CCol md="3" sm="12">
        <c-widget-progress-icon
            :header="data.count.exam"
            color="gradient-info"
            text="Exam questions">
          <CIcon height="36" name="cil-bank"/>
        </c-widget-progress-icon>
      </CCol>
      <CCol md="3" sm="12">
        <c-widget-progress-icon
            :header="data.count.examSet"
            color="gradient-info"
            text="Exam Question Sets"
        >
          <CIcon height="36" name="cil-copy"/>
        </c-widget-progress-icon>
      </CCol>
      <CCol md="3" sm="12">
        <CWidgetIcon
            :header="data.count.course.toString()"
            class="mb-1"
            color="gradient-info"
            style="height: 38.5%"
            text="Courses"
        >
          <CIcon height="26" name="cil-book"/>
        </CWidgetIcon>
        <CWidgetIcon
            :header="data.count.topic.toString()"
            color="gradient-danger"
            style="height: 38.5%"
            text="Topics"
        >
          <CIcon height="26" name="cil-description"/>
        </CWidgetIcon>
      </CCol>
      <CCol md="3" sm="12">
        <CWidgetIcon
            :header="data.count.calculatedExam.toString()"
            class="mb-1"
            color="gradient-success"
            style="height: 38.5%"
            text="Calculated exam"
        >
          <CIcon height="26" name="cil-copy"/>
        </CWidgetIcon>
        <CWidgetIcon
            :header="data.count.analysis.toString()"
            color="gradient-warning"
            style="height: 38.5%"
            text="Analysis"
        >
          <CIcon height="26" name="cil-calculator"/>
        </CWidgetIcon>
      </CCol>
    </CRow>
    <CRow style="margin-top: -1.5rem">
      <CCol md="4" sm="12">
        <CWidgetBrand
            :left-header="data.average.difficulty"
            :right-header="data.average.difficultyIndex.toString()"
            color="linkedin"
            left-footer="Difficulty"
            right-footer="out of 1"
        >
          <div class="my-4">
            <span class="font-weight-bold font-xl mb-2">Average</span><br/>
            <span class="font-weight-bold font-xl">Difficulty Index</span>
          </div>
        </CWidgetBrand>
      </CCol>
      <CCol md="4" sm="12">
        <CWidgetBrand
            :left-header="data.average.quality"
            :right-header="data.average.discriminationIndex.toString()"
            color="linkedin"
            left-footer="quality"
            right-footer="out of 1"
        >
          <div class="my-4">
            <span class="font-weight-bold font-xl mb-2">Average</span><br/>
            <span class="font-weight-bold font-xl">Discrimination Index</span>
          </div>
        </CWidgetBrand>
      </CCol>
      <CCol md="4" sm="12">
        <CWidgetBrand
            :left-header="data.average.reliability.split(' ')[0]"
            :right-header="data.average.krTwenty.toString()"
            color="linkedin"
            left-footer="Correlation"
            right-footer="out of 1"
        >
          <div class="my-4">
            <span class="font-weight-bold font-xl mb-2">Average</span><br/>
            <span class="font-weight-bold font-xl">KR-20 Index</span>
          </div>
        </CWidgetBrand>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6" sm="12">
        <CRow>
          <CCol md="6" sm="12">
            <c-widget-progress-icon
                :header="data.count.teacher"
                color="gradient-info"
                text="Teachers">
              <CIcon height="36" name="cil-group"/>
            </c-widget-progress-icon>
          </CCol>
          <CCol md="6" sm="12">
            <c-widget-progress-icon
                :header="data.count.keyword"
                color="gradient-info"
                text="Keywords"
            >
              <CIcon height="36" name="cil-tags"/>
            </c-widget-progress-icon>
          </CCol>
        </CRow>
      </CCol>

      <CCol md="6" sm="12">
        <CCard>
          <CCardHeader>
            Question Type ({{ data.count.exam }} items)
          </CCardHeader>
          <CCardBody class="pt-1 pb-1">
            <div class="progress-group mt-2">
              <div class="progress-group-header">
                <CIcon class="progress-group-icon" name="cil-sign-language"/>
                <span class="title">Application</span>
                <span class="ml-auto font-weight-bold">
                                {{ data.count.questionType.application }} <span class="text-muted small">({{
                    data.count.questionType.application === 0 ? 0 : ((data.count.questionType.application / data.count.exam) * 100).toFixed(2)
                  }}%)</span>
                              </span>
              </div>
              <div class="progress-group-bars">
                <CProgress
                    :value="(data.count.questionType.application / data.count.exam)*100"
                    class="progress-xs"
                    color="success"
                />
              </div>
            </div>
            <div class="progress-group mt-3">
              <div class="progress-group-header">
                <CIcon class="progress-group-icon" name="cil-list-filter"/>
                <span class="title">Understanding</span>
                <span class="ml-auto font-weight-bold">
                                {{ data.count.questionType.understanding }} <span class="text-muted small">({{
                    data.count.questionType.understanding === 0 ? 0 : ((data.count.questionType.understanding / data.count.exam) * 100).toFixed(2)

                  }}%)</span>
                              </span>
              </div>
              <div class="progress-group-bars">
                <CProgress
                    :value="(data.count.questionType.understanding / data.count.exam)*100"
                    class="progress-xs"
                    color="warning"
                />
              </div>
            </div>
            <div class="progress-group">
              <div class="progress-group-header">
                <CIcon class="progress-group-icon" name="cil-lightbulb"/>
                <span class="title">Remembering</span>
                <span class="ml-auto font-weight-bold">
                                {{ data.count.questionType.remembering }} <span class="text-muted small">({{
                    data.count.questionType.remembering === 0 ? 0 : ((data.count.questionType.remembering / data.count.exam) * 100).toFixed(2)
                  }}%)</span>
                              </span>
              </div>
              <div class="progress-group-bars">
                <CProgress
                    :value="(data.count.questionType.remembering / data.count.exam)*100"
                    class="progress-xs"
                    color="danger"
                />
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import CWidgetProgressIcon from "@/components/widget/CWidgetProgressIcon";

export default {
  name: "Dashboard",
  components: {
    CWidgetProgressIcon
  },
  data() {
    return {
      state: false,
      data: {
        count: {
          course: 0,
          topic: 0,
          keyword: 0,
          teacher: 0,
          exam: 0,
          examSet: 0,
          calculatedExam: 0,
          analysis: 0,
          questionType: {
            application: 0,
            understanding: 0,
            remembering: 0
          }
        },
        average: {
          difficultyIndex: 0,
          discriminationIndex: 0,
          krTwenty: 0,
          quality: "-",
          difficulty: "-",
          reliability: "-"
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("user/onSetDashboard")
  },
  computed: {
    ...mapGetters({
      dashboard: "user/getDashboard"
    })
  },
  watch: {
    dashboard(value) {
      this.state = true
      this.data = value
    }
  }
}
</script>
